import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=56a1ed8f&scoped=true"
import script from "./PermissionManager.vue?vue&type=script&lang=js"
export * from "./PermissionManager.vue?vue&type=script&lang=js"
import style0 from "./PermissionManager.vue?vue&type=style&index=0&id=56a1ed8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1ed8f",
  null
  
)

export default component.exports